import clsx from "clsx";

interface Props {
  outline?: boolean;
  type?: "submit" | "button";
  children: string;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  color?: "gray" | "primary" | "green" | "lightgray";
}

const Button = ({
  type = "button",
  outline,
  color = "gray",
  children,
  onClick,
  className,
  disabled,
}: Props) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={clsx(
        "inline-flex items-center justify-center rounded-md h-14 font-bold text-16 duration-300 disabled:cursor-not-allowed",
        {
          "bg-secondary text-white": !outline && color === "gray",
          "border bg-white border-secondary text-secondary":
            outline && color === "gray",
          "bg-primary text-white": !outline && color === "primary",
          "bg-green text-white": !outline && color === "green",
          "border bg-white border-primary text-primary":
            outline && color === "primary",
          "bg-[#E1E1E1] text-secondary": !outline && color === "lightgray",
        },
        className,
      )}
    >
      {children}
    </button>
  );
};

export default Button;
